import React, { useEffect, useState } from "react";
import Main from "../components/Main/Main";
import PageLoader from "../components/PageLoader/PageLoader";
import usePrize from "../hooks/usePrize";
import useAgeVerification from "../hooks/useAgeVerification";
import { doublePrizeData, singlePrizeData } from "../lib/static-data";
import CtaButtonLayout from "../components/CtaButtonLayout/CtaButtonLayout";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import MetaTags from "../components/meta-tags";
import AgeVerificationPopup from "../components/common/AgeVerificationPopup";
import useWidget from "../hooks/useWidget";
import { getGeneralContent } from "../services/generalContent";
import { getBonusDraw } from "../services/bonusDraw";

function HomePage(props) {
  const {
    raffle,
    prizeId,
    prizeLoading,
    raffles,
    isExpired,
    activeRaffles,
    subscriptionModels,
    isDoublePrize,
  } = usePrize();

  const [content, setContent] = useState({});
  const [bonusDraw, setBonusDraw] = useState(null);
  const { showAgePopup, requireAgeVerification, confirmAge, closeAgePopup } = useAgeVerification();

  const getPageContent = async () => {
    const pageContent = await getGeneralContent();
    if (pageContent.dreamHome) {
      setContent(pageContent);
    }
  };

  const getActiveBonusDraw = async () => {
    const activeBonusDraw = await getBonusDraw();
    if (activeBonusDraw && activeBonusDraw.length) {
      setBonusDraw(activeBonusDraw[0]);
    }
  };

  useEffect(() => {
    getPageContent();
    getActiveBonusDraw();
  }, []);

  const { widget: timelineWidget, isWidgetLoading: isTimelineWidgetLoading } =
    useWidget({ type: "timeline-logo-rotation-text" });
  const { widget: footerWidget, isWidgetLoading: isFooterWidgetLoading } =
    useWidget({ type: "footer-logo-rotation-text" });

  const onClickExternalLink = (endpoint) => {
    if (process.env.REACT_APP_BASE_URL) {
      window.open(process.env.REACT_APP_BASE_URL + endpoint, '_self');
    }
  }
  const onCTAClick = () =>
    requireAgeVerification(() => onClickExternalLink(`/ticket-selector`));
  const onTwo4One = () => onClickExternalLink(`/2-4-1`);
  const onLearnMoreClick = () => onClickExternalLink(`/how-it-works`);
  const onLearnMoreCharityClick = () => onClickExternalLink(`/charity-raffle`);
  const onEnterNowClick = () =>
    requireAgeVerification(() => onClickExternalLink(`/ticket-selector`));

  const isLoading =
    prizeLoading || isTimelineWidgetLoading || isFooterWidgetLoading;

  return (
    <>
      <MetaTags />
      {isLoading ? (
        <CtaButtonLayout isDark>
          <Header raffle={raffle} />
          <PageLoader loading />
          <Footer insideComponent={true} widget={footerWidget} />
        </CtaButtonLayout>
      ) : (
        <Main
          prize={null}
          prizeId={prizeId}
          raffle={raffle}
          raffles={raffles}
          subscriptionModels={subscriptionModels}
          activeRaffles={activeRaffles}
          isExpired={isExpired}
          data={isDoublePrize ? doublePrizeData : singlePrizeData}
          onCTAClick={onCTAClick}
          onTwo4One={onTwo4One}
          onLearnMoreClick={onLearnMoreClick}
          onLearnMoreCharityClick={onLearnMoreCharityClick}
          onEnterNowClick={onEnterNowClick}
          widgets={{ timelineWidget, footerWidget }}
          content={content}
          bonusDraw={bonusDraw}
        />
      )}
      {showAgePopup && (
        <AgeVerificationPopup onConfirm={confirmAge} onClose={closeAgePopup} />
      )}
    </>
  );
}

export default HomePage;
